import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  chiefComplaintTechnicianAdvices: [],
  allChiefComplaintTechnicianAdvices: [],
  totalPages: 0,
  totalRecords: 0,
  chiefComplaintTechnicianAdvice: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_119: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_ChiefComplaintTechnicianAdvices(state, chiefComplaintTechnicianAdvices) {
    state.chiefComplaintTechnicianAdvices = chiefComplaintTechnicianAdvices.items;
    state.totalPages = chiefComplaintTechnicianAdvices.totalPages;
    state.totalRecords = chiefComplaintTechnicianAdvices?.totalRecords ?? 0;
  },
  SET_AllChiefComplaintTechnicianAdvices(state, chiefComplaintTechnicianAdvices) {
    state.allChiefComplaintTechnicianAdvices = chiefComplaintTechnicianAdvices;
  },
  SET_ChiefComplaintTechnicianAdvice(state, chiefComplaintTechnicianAdvice) {
    state.chiefComplaintTechnicianAdvice = chiefComplaintTechnicianAdvice;
  },
};
const actions = {
  errorChiefComplaintTechnicianAdvice({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllChiefComplaintTechnicianAdvicesDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/ChiefComplaintTechnicianAdvices/All', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllChiefComplaintTechnicianAdvices', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaintTechnicianAdvice', error);
      });
  },
  addChiefComplaintTechnicianAdviceDispatch({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/ChiefComplaintTechnicianAdvices', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaintTechnicianAdvice', error);
      });
  },
  getChiefComplaintTechnicianAdviceDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/ChiefComplaintTechnicianAdvices/ById', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_ChiefComplaintTechnicianAdvice', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaintTechnicianAdvice', error);
      });
  },
  editChiefComplaintTechnicianAdviceDispatch({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/ChiefComplaintTechnicianAdvices/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaintTechnicianAdvice', error);
      });
  },
  deleteChiefComplaintTechnicianAdviceDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .post('/ChiefComplaintTechnicianAdvices/Remove', null, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params,
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaintTechnicianAdvice', error);
      });
  },
  activeChiefComplaintTechnicianAdviceDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .post('/ChiefComplaintTechnicianAdvices/Activate', null, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params,
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaintTechnicianAdvice', error);
      });
  },
  deactiveChiefComplaintTechnicianAdviceDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .post('/ChiefComplaintTechnicianAdvices/Deactivate', null, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params,
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaintTechnicianAdvice', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
